export const setSourceCompletePayouts = {
  SET_SOURCE_COMPLETE_PAYOUTS(state, payload) {
    state.sourceCompletePayouts = payload;
  }
};
